import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/gloable.css'
import request from "@/utils/request";
import './permission'
import './assets/icons' // icon

import '@/assets/styles/index.scss' // global css
import '@/assets/styles/ruoyi.scss' // ruoyi css
import './assets/styles/element-variables.scss'
import './assets/styles/runtime-theme.scss'

import Print from 'vue-print-nb'

import plugins from './plugins' // plugins

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

ElementUI.Select.props.popperAppendToBody.default = false;
ElementUI.DatePicker.props.appendToBody = false;
ElementUI.TimePicker.props.appendToBody = false;
Vue.use(ElementUI,{size:"mini"});
Vue.use(plugins)
Vue.use(Print)

Vue.prototype.request=request

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
